var map = {
	"./ADA.png": "68b9",
	"./ALGO.png": "0089",
	"./ATOM.png": "3b68",
	"./AVAX.png": "3729",
	"./BCH.png": "783e",
	"./BTC.png": "20f0",
	"./DOGE.png": "84ce",
	"./DOT.png": "bb42",
	"./ETH.png": "022a",
	"./FTM.png": "bba5",
	"./ICP.png": "d45c",
	"./LTC.png": "f23b",
	"./LUNA.png": "b1b6",
	"./MATIC.png": "c0fe",
	"./NEAR.png": "56b8",
	"./SOL.png": "5acb",
	"./TRX.png": "88af",
	"./VET.png": "ce16",
	"./XLM.png": "67ea",
	"./XRP.png": "8b86"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f4b";